import { useEffect, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"

import { getOnboardingAccess } from "../../../../../Utils/onboarding/getOnboardingAccess.js"
import { onboardingStepPath } from "../../../../../Utils/utils.js"
import { sendConfirmEmail as sendConfirmEmailThunk } from "../../../../LoginPage/redux/auth.thunks.js"
import { getOnboardingSteps } from "../../../utils/getOnboardingSteps.js"
import { getResendDeadline } from "../../../utils/getResendDeadline.js"
import { OB_STEPS } from "../../../utils/onboardingSteps.js"

const useOnboardingStepsBlock = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const new_onboarding_finished = useSelector(
    (state) => state.auth.userInfo.new_onboarding_finished
  )
  const email = useSelector((state) => state.auth.userInfo.email)
  const nextStep = useSelector((state) => state.auth?.userInfo?.next_step)
  const confirmEmailTimeToNextTry = useSelector((state) => state.auth.confirmEmailTimeToNextTry)

  const [openModal, setOpenModal] = useState(false)
  const [initStep, setInitStep] = useState("form")
  const [resendDeadline, setResendDeadline] = useState(null)

  const totalSteps = 1

  const onboardingSteps = getOnboardingSteps({
    email,
    isEdit: true,
    isVerify: true
  })
  const steps = onboardingSteps

  const { isStepCompleted, isStepCurrent, completedPrimarySteps, completedSecondarySteps } =
    getOnboardingAccess({
      nextCreateAccountStep: new_onboarding_finished ? nextStep + 1 : nextStep
    })

  const preparedSteps = steps.map((s) => ({
    ...s,
    isCompleted: isStepCompleted(s.step),
    isContinue: isStepCurrent(s.step) && s.step !== OB_STEPS.EMAIL
  }))

  const isVerifyCooldownActive = !!resendDeadline && resendDeadline > Date.now()

  const sendConfirmEmail = () => {
    if (isVerifyCooldownActive) return

    dispatch(sendConfirmEmailThunk({ email }))
  }

  const handleOpenModal = (step) => {
    if (step === "sent") {
      sendConfirmEmail()
    }
    setOpenModal(true)
    setInitStep(step)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleResend = () => {
    sendConfirmEmail()
  }

  const handleContinue = (step) => {
    navigate(onboardingStepPath[step])
  }

  useEffect(() => {
    if (!resendDeadline) return
    const timeout = resendDeadline - Date.now()
    if (timeout <= 0) {
      setResendDeadline(null)
      return
    }
    const timerId = setTimeout(() => {
      setResendDeadline(null)
    }, timeout)
    return () => clearTimeout(timerId)
  }, [resendDeadline])

  useEffect(() => {
    if (!confirmEmailTimeToNextTry) return
    setResendDeadline(getResendDeadline(confirmEmailTimeToNextTry))
  }, [confirmEmailTimeToNextTry])

  return {
    email,
    openModal,
    initStep,
    resendDeadline,
    totalSteps,
    preparedSteps,
    handleContinue,
    handleOpenModal,
    handleCloseModal,
    handleResend,
    verifyButtonState: {
      disabled: isVerifyCooldownActive
    },
    completedPrimarySteps,
    completedSecondarySteps
  }
}

export default useOnboardingStepsBlock
